var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    id: "icon",
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    "data-name": "<Transparent Rectangle>",
    height: 32,
    id: "_Transparent_Rectangle_",
    width: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubl);
export default __webpack_public_path__ + "static/media/rubl.bfa0f3c9f58101b816b472573999bf65.svg";
export { ForwardRef as ReactComponent };